import { computed, ref } from 'vue';

export interface LayoutBackgroundOptions {
    color?: string;
    image?: string;
    size?: string;
    position?: string;
    repeat?: string;
    attachment?: string;
}

type LayoutBackgroundInput = string | LayoutBackgroundOptions;

const layoutBackground = ref<LayoutBackgroundInput>('');

const normalizeBackgroundImage = (image: string) => {
    if (!image) return '';
    if (image.includes('url(') || image.startsWith('linear-gradient') || image.startsWith('radial-gradient')) {
        return image;
    }
    return `url("${image}")`;
};

export function useLayoutBackground() {
    const layoutBackgroundStyle = computed<Record<string, string>>(() => {
        const value = layoutBackground.value;

        if (typeof value === 'string') {
            return value
                ? {
                      background: value,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                  }
                : {};
        }

        const style: Record<string, string> = {};
        if (value.color) style.backgroundColor = value.color;
        if (value.image) style.backgroundImage = normalizeBackgroundImage(value.image);
        if (value.size) style.backgroundSize = value.size;
        if (value.position) style.backgroundPosition = value.position;
        if (value.repeat) style.backgroundRepeat = value.repeat;
        if (value.attachment) style.backgroundAttachment = value.attachment;
        return style;
    });

    const setLayoutBackground = (value: LayoutBackgroundInput) => {
        layoutBackground.value = value;
    };

    const resetLayoutBackground = () => {
        layoutBackground.value = '';
    };

    return {
        layoutBackground,
        layoutBackgroundStyle,
        setLayoutBackground,
        resetLayoutBackground,
    };
}
